var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"nav-buttons-side"},[_c('router-link',{attrs:{"to":"/"}},[_vm._v(_vm._s(_vm.data.title))]),_c('BaseIcon',{staticClass:"nav-buttons-side__icon",attrs:{"name":"chevron_right","size":"22"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }